import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    visibleSlides: ['q_0'],
    questions: [{
        type: 'text',
        text: 'After you’ve cleaned and dried a cut or graze, what should you do?',
        options: [{
          text: 'Cover it with a sterile dressing'
        }, {
          text: 'Leave it open to the air'
        }],
        correctAnswer: 'Cover it with a sterile dressing',
        userAnswer: null,
        resultText: '<strong>Cover it with a sterile dressing -</strong> Minor cuts and grazes should be cleaned with tap water, patted dry and then covered with a plaster or sterile dressing. <a href="https://www.nhs.uk/conditions/cuts-and-grazes/" target="_blank" class="answer-link">See NHS advice on cuts and grazes</a>.',
        resultTextMobile: 'Minor cuts and grazes should be cleaned with tap water, patted dry and then covered with a plaster or sterile dressing. <a href="https://www.nhs.uk/conditions/cuts-and-grazes/" target="_blank" class="answer-link">See NHS advice on cuts and grazes</a>.',
        showOverlay: false
      },
      {
        type: 'text',
        text: 'When someone has a nosebleed they should pinch their nose and tilt their head - which way?',
        options: [{
          text: 'Backward'
        }, {
          text: 'Forward'
        }],
        correctAnswer: 'Forward',
        userAnswer: null,
        resultText: '<strong>Forward -</strong> Most nosebleeds can be treated by pinching your nose above the nostrils, breathing through your mouth, applying an ice pack and tilting your head forward for 10-15 minutes. Nosebleeds aren’t usually serious, but sometimes can be - <a href="https://www.nhs.uk/conditions/nosebleed/" target="_blank" class="answer-link">see NHS advice on nosebleeds</a>.',
        resultTextMobile: 'Most nosebleeds can be treated by pinching your nose above the nostrils, breathing through your mouth, applying an ice pack and tilting your head forward for 10-15 minutes. Nosebleeds aren’t usually serious, but sometimes can be - <a href="https://www.nhs.uk/conditions/nosebleed/" target="_blank" class="answer-link">see NHS advice on nosebleeds</a>.',
        showOverlay: false
      },
      {
        type: 'text',
        text: 'You’ve got a bad blister. Should you burst it or leave it alone?',
        options: [{
          text: 'Burst it'
        }, {
          text: 'Leave it'
        }],
        correctAnswer: 'Leave it',
        userAnswer: null,
        resultText: '<strong>Leave it -</strong> Blisters should heal on their own. If you think one is about to burst, cover it with a sterile dressing. Don’t burst it yourself as it could get infected. If you think a blister is infected, see a doctor. <a href="https://www.nhs.uk/conditions/blisters/" target="_blank" class="answer-link">See NHS advice on blisters</a>.',
        resultTextMobile: 'Blisters should heal on their own. If you think one is about to burst, cover it with a sterile dressing. Don’t burst it yourself as it could get infected. If you think a blister is infected, see a doctor. <a href="https://www.nhs.uk/conditions/blisters/" target="_blank" class="answer-link">See NHS advice on blisters</a>.',
        showOverlay: false
      },
      {
        type: 'text',
        text: 'What’s the best way to position someone who feels faint?',
        options: [{
          text: 'Lying down, legs raised'
        }, {
          text: 'Sitting against a wall'
        }],
        correctAnswer: 'Lying down, legs raised',
        userAnswer: null,
        resultText: '<strong>Lying down, legs raised -</strong> If someone feels faint, putting them in this position will help blood flow back to the brain. If that’s not possible, sit them with their head between their knees. If they do faint and are unconscious for more than a minute or two, put them into the recovery position, call 999 and wait with them for an ambulance. <a href="https://www.nhs.uk/conditions/fainting/" target="_blank" class="answer-link">See NHS advice on fainting</a>.',
        resultTextMobile: 'If someone feels faint, putting them in this position will help blood flow back to the brain. If that’s not possible, sit them with their head between their knees. If they do faint and are unconscious for more than a minute or two, put them into the recovery position, call 999 and wait with them for an ambulance. <a href="https://www.nhs.uk/conditions/fainting/" target="_blank" class="answer-link">See NHS advice on fainting</a>.',
        showOverlay: false
      },
      {
        type: 'text',
        text: 'Which of these should you put on a strained muscle?',
        options: [{
          text: 'Ice pack'
        }, {
          text: 'Hot water bottle'
        }],
        correctAnswer: 'Ice pack',
        userAnswer: null,
        resultText: '<strong>An ice pack -</strong> To treat a sprain or strain, rest the injured body part, bandage it, keep it elevated and put an ice pack on it for up to 20 minutes every two to three hours for the first few days. <a href="https://www.nhs.uk/conditions/sprains-and-strains/" target="_blank" class="answer-link">See NHS advice on strains and sprains</a>.',
        resultTextMobile: 'To treat a sprain or strain, rest the injured body part, bandage it, keep it elevated and put an ice pack on it for up to 20 minutes every two to three hours for the first few days. <a href="https://www.nhs.uk/conditions/sprains-and-strains/" target="_blank" class="answer-link">See NHS advice on strains and sprains</a>.',
        showOverlay: false
      },
      {
        type: 'img',
        text: 'Which picture shows someone being put in the recovery position?',
        options: [{
          text: 'A'
        }, {
          text: 'B'
        }, {
          text: 'C'
        }],
        correctAnswer: 'C',
        userAnswer: null,
        resultText: '<strong>Image C showed the recovery position -</strong> Putting someone into this position helps keep their airway clear and open. <a href="https://www.nhs.uk/conditions/first-aid/recovery-position/" target="_blank" class="answer-link">See NHS advice on the recovery position</a>.',
        resultTextMobile: 'Putting someone into this position helps keep their airway clear and open. <a href="https://www.nhs.uk/conditions/first-aid/recovery-position/" target="_blank" class="answer-link">See NHS advice on the recovery position</a>.',
        showOverlay: false
      },
      {
        type: 'text',
        text: 'You burn your hand in the kitchen - what should you do first?',
        options: [{
          text: 'Cover it with cling film'
        }, {
          text: 'Cool it under running water'
        }],
        correctAnswer: 'Cool it under running water',
        userAnswer: null,
        resultText: '<strong>Cool it under running water -</strong> Burns should be cooled as soon as possible under running water, for at least 20 minutes. If the burn is serious, call 999 or seek medical attention. <a href="https://www.nhs.uk/conditions/first-aid/" target="_blank" class="answer-link">See NHS first aid advice</a>.',
        resultTextMobile: 'Burns should be cooled as soon as possible under running water, for at least 20 minutes. If the burn is serious, call 999 or seek medical attention. <a href="https://www.nhs.uk/conditions/first-aid/" target="_blank" class="answer-link">See NHS first aid advice</a>.',
        showOverlay: false
      },
    ],
    result: 0,
    firstName: '',
    variants: {
      facebookText: 0,
      facebookImg: 0,
      whatsapp: 0
    },
  },
  mutations: {
    answerQuestion(state, payload) {
      //Save answer
      state.questions[payload.question].userAnswer = payload.choice.text;
      //Calc result
      var score = 0;
      state.questions.forEach(function (question) {
        if (question.userAnswer == question.correctAnswer) {
          score++;
        }
      });
      state.result = score;
    }
  },
  actions: {

  }
})